// eslint-disable-next-line import/extensions
import { SERVER_SIDE_TRANSACTION_ACTION_CODES } from '@/utils/constants';

// These action handlers should not return any data as we only want to keep this file to perform actions only.
export const ServerActionMixin = {
    methods: {
        $_actionHandler(action) {
            if (!action || !action.actionCode) 
                return;

            const actionMap = this.$_mapActionCodes();
            const actionHandler = actionMap[action.actionCode];

            if (actionHandler) {
                actionHandler(action.data, action.query);
            }
        },
        $_handleChangeTab(data, query) {
            if (!data || data === 'null' || !query || query === 'null') 
                return;

            this.$router.push({ path: `${data}${query}` });
        },
        $_mapActionCodes() {
            const actionMap = {
                [SERVER_SIDE_TRANSACTION_ACTION_CODES.ChangeTab]: this.$_handleChangeTab
            };

            return actionMap;
        }
    },
    data() {
        return {
            SERVER_SIDE_TRANSACTION_ACTION_CODES
        };
    }
};
